import { createSelector, Selector } from 'reselect'

import { BalanceState } from './balance.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetBalance = Selector<RootState, BalanceState>
const getBalance: GetBalance = (state) => state.balance

export const selectBalanceAmount = (subscriptionId: string) =>
  createSelector(getBalance, (data) => data[subscriptionId]?.balance?.data?.amount)

export const selectBalanceLoading = (subscriptionId: string) =>
  createSelector(getBalance, (data) => data[subscriptionId]?.balance?.loading)

export const selectBalanceError = (subscriptionId: string) =>
  createSelector(getBalance, (data) => data[subscriptionId]?.balance?.error)

export const selectRecharges = (subscriptionId: string) =>
  createSelector(getBalance, (data) => data[subscriptionId]?.recharges?.data?.recharges)

export const selectRechargesLoading = (subscriptionId: string) =>
  createSelector(getBalance, (data) => data[subscriptionId]?.recharges?.loading)

export const selectRechargesError = (subscriptionId: string) =>
  createSelector(getBalance, (data) => data[subscriptionId]?.recharges?.error)
